import Meta from "../util/Meta";

export class ExtratoColaborador {
    // TODO: Extrato Completo do Colaborador
    static async getExtratoGeral(matricula: string, data_inicio: string, data_fim: string): Promise<IExtrato[]> {
        const queryParams = new URLSearchParams({
            data_inicio: !data_inicio ? new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().split('T')[0] : data_inicio,
            data_fim: !data_fim ? new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).toISOString().split('T')[0] : data_fim
        });
        const url = `${Meta.get('root')}/extrato/geral/${matricula}?${queryParams.toString()}`;


        return await new Promise((res, rej) => {
            fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                }
            })
                .then(res => {
                    if (res.status === 200) {
                        return res.json() as Promise<IExtrato[]>;
                    } else if (res.status === 404 || res.status === 400) {
                        return [];
                    } else {
                        throw new Error(`Erro inesperado: [${res.status}] ${res.statusText}`);
                    }
                })
                .then(res)
                .catch(rej);
        });
    }


    static async getExtratoGm(cpf: string, data_inicio: string, data_fim: string): Promise<IExtrato[]> {
        data_inicio = !data_inicio ? new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().split('T')[0] : data_inicio;
        data_fim = !data_fim ? new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).toISOString().split('T')[0] : data_fim;

        const api_url = 'https://espacodigital.sescrn.com.br/clinica-integrada/gm/consumo'; //'http://10.84.0.84:8080/clinica-integrada/gm/consumo'

        return await new Promise((res, rej) => {
            fetch(`${api_url}?cpf=${cpf}&data_inicio=${data_inicio}&data_fim=${data_fim}`,{
                method: 'GET',
                headers: {
                    'WWW-Authenticate': 'Basic realm = dXNlcl9zeXN0ZW06MkhuODgjTEozZmJJ'
                }
            })
                .then(res => {
                    if (res.status === 200) {
                        return res.json() as Promise<IExtrato[]>;
                    } else if (res.status === 404 || res.status === 400) {
                        return [];
                    } else if (res.status == 403) {
                        throw new Error('Desculpe, você não tem permissão de acessar essa rota.');
                    } else {
                        throw new Error(`Erro inesperado: [${res.status}] ${res.statusText}`);
                    }
                })
                .then(res)
                .catch(rej);
        });
    }
}

export interface IExtrato {
    id: number;
    descricao: string;
    data: Date;
    status: string;
    valor: number;
    categoria: string;
}
